import React, { ComponentProps, PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  isOpen: boolean;
  onClick: () => void;
  style?: React.CSSProperties;
  onBlur?: () => void;
}>;

export const ContextMenu = ({
  isOpen,
  onClick,
  children,
  style,
  onBlur,
}: Props): React.ReactElement => {
  return (
    <>
      <div
        className="relative flex items-center justify-center"
        tabIndex={0}
        style={style}
        onBlur={onBlur}>
        <div
          className="icon-more-vertical p-1 -m-1"
          {...{
            onClick: (e): void => {
              e.stopPropagation();
              onClick();
            },
          }}
        />
        {isOpen && (
          <div className="absolute right-0 top-0 mt-4 mr-1 z-10">
            {children}
          </div>
        )}
      </div>
    </>
  );
};

export const ContextMenuContainer = ({
  children,
}: PropsWithChildren<Record<string, unknown>>): React.ReactElement => {
  return (
    <>
      <div
        className="bg-white flex flex-col rounded-lg border border-bluegray-400 p-4"
        style={{ gap: '0.75rem' }}>
        {children}
      </div>
    </>
  );
};

export const ContextMenuRow = ({
  icon,
  onClick,
  rowName,
  className,
}: {
  icon: string;
  rowName: string;
  onClick: () => void;
  className?: string;
}): React.ReactElement => {
  return (
    <>
      <div
        className={`flex flex-row items-center ${className ?? ''}`}
        {...{
          onClick: e => {
            e.stopPropagation();
            onClick();
          },
        }}>
        <div className={`icon-${icon} mr-2 text-gray-700`} />
        <div className="text-bluegray-700 whitespace-no-wrap text-sm">
          {rowName}
        </div>
      </div>
    </>
  );
};

export const getTargetContextMenuRows = ({
  editTitle,
  endTarget,
  ...rest
}: {
  editTitle: () => void;
  endTarget: () => void;
} & (
  | {
      updateTarget: () => void;
    }
  | {
      editTargetAmount: () => void;
    }
)): (ComponentProps<typeof ContextMenuRow> & { key: string })[] => [
  {
    icon: 'edit',
    rowName: 'タイトルの編集',
    onClick: editTitle,
    key: 'タイトルの編集',
  },
  'updateTarget' in rest
    ? {
        icon: 'rotate-ccw',
        rowName: '目標設定の見直し',
        onClick: rest.updateTarget,
        key: '目標設定の見直し',
      }
    : {
        icon: 'rotate-ccw',
        rowName: '目標金額の見直し',
        onClick: rest.editTargetAmount,
        key: '目標金額の見直し',
      },
  {
    icon: 'trash',
    rowName: '目標を終了する',
    onClick: endTarget,
    key: '目標を終了する',
  },
];
